export const SET_DRUG_FILTER = '@DRUG/SET_DRUG_FILTER';
export const RESET_DRUG_FILTER = '@DRUG/RESET_DRUG_FILTER';

export const SET_LIST_MESSAGE = '@DRUG/SET_LIST_MESSAGE';
export const GET_DRUG_SUMMARY = '@DRUG/GET_DRUG_SUMMARY';

export const SET_DRUG_PENDING_FILTER = '@DRUG/SET_DRUG_PENDING_FILTER';
export const RESET_DRUG_PENDING_FILTER = '@DRUG/RESET_DRUG_PENDING_FILTER';

export const setDrugFilter = (filter) => {
  return (dispatch) => {
    dispatch({ type: SET_DRUG_FILTER, payload: { filter } });
  };
};

export const getDrugSummary = (total) => {
  return (dispatch) => {
    dispatch({ type: GET_DRUG_SUMMARY, payload: total });
  };
};

export const resetDrugFilter = () => {
  return (dispatch) => {
    dispatch({ type: RESET_DRUG_FILTER });
  };
};

export const setListMessage = (message) => {
  return (dispatch) => {
    dispatch({ type: SET_LIST_MESSAGE, payload: { message } });
  };
};

export const setDrugPendingFilter = (filter) => {
  return (dispatch) => {
    dispatch({ type: SET_DRUG_PENDING_FILTER, payload: { filter } });
  };
};

export const resetDrugPendingFilter = () => {
  return (dispatch) => {
    dispatch({ type: RESET_DRUG_PENDING_FILTER });
  };
};
